module.exports = __webpack_public_path__ + "img/Why_American_Credit_Customer_Voice.ad8a0fa.png";